export default "__VITE_ASSET__6a2b4106__"